module.exports = __webpack_public_path__ + "img/album17_20.ff03e30b.jpg";